import { get } from '@/api/implementation/app/index.js';

export const index = () => {
  return get('country');
}
